import axios from 'axios';

export default async (commit, getters) => {
    let data;

    if (getters.isSelfUpgrading) {
        try {
            ({data} = await axios.post('/api/v1/validate/jwt', {
                token: getters.purchaseInfo.token,
            }));
            if (!data.subscriptionId) {
                commit('setLinkError', {
                    active: true,
                });
                commit('setInitialLoading', false);
                return;
            }
            commit('updateUserInfo', {
                subscriptionId: data.subscriptionId
            });
        } catch (error) {
            if (window.axios.isAxiosError(error)) {
                if (!!error.response) {
                    const errorObj = error.response.data;
                    window.Sentry.logError(error, {server_event_id: error.response.data.eventId});
                    commit('setLinkError', {
                        active: true,
                        code: errorObj.error,
                    });
                    return;
                } else {
                    window.Sentry.logError(error);
                    commit('setLinkError', {
                        active: true,
                        code: window.constants.errorCodes.generalError,
                    });
                }
            } else if (!getters.hasActiveError) {
                window.Sentry.logError(error);
                commit('setLinkError', {
                    active: true,
                    code: window.constants.errorCodes.generalError
                });
            }
            commit('setInitialLoading', false);
            return;
        }
    }
}
